import { UserService } from 'modules/user';

const DEFAULT_DIGITS = 2;

class Number {
  static get hasIntlSupport() {
    return Intl && Intl.NumberFormat;
  }

  get locale() {
    try {
      const userLanguage = UserService.language.replace('_', '-');
      const locale = Intl.getCanonicalLocales(userLanguage)[0];

      return locale;
      // eslint-disable-next-line no-empty
    } catch {}
  }

  format(number, options) {
    if (Number.hasIntlSupport) {
      return this.formatWithIntl(number, options);
    }

    return number;
  }

  ceil(number, precision) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const magnitude = Math.pow(10, precision);

    return Math.ceil(number * magnitude) / magnitude;
  }

  floor(number, precision) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const magnitude = Math.pow(10, precision);

    return Math.floor(number * magnitude) / magnitude;
  }

  formatWithIntl(number, options = {}) {
    try {
      return new Intl.NumberFormat(this.locale, options).format(number);
    } catch {
      return number;
    }
  }

  formatPercentVariation = (value = 0, nDigits = DEFAULT_DIGITS) =>
    `${value ? value.toFixed(nDigits) : 0}%`;
}

export default new Number();
